module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "max-width": "500px"
    },
    attrs: {
      "id": "login-overlay"
    }
  }, [(_vm.authenticatedComp) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.userRoleComp == 'Sitter') ? _c('h3', {
    staticClass: "text-center modal-title"
  }, [_vm._v(" You are logged in as a Sitter")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Client') ? _c('h3', {
    staticClass: "text-center modal-title"
  }, [_vm._v(" You are logged in as a Customer")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "text-center",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goAccount()
      }
    }
  }, [_vm._v("Go to account to switch role")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Back")])])])]) : _vm._e(), _vm._v(" "), (!_vm.authenticatedComp) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-center",
    staticStyle: {
      "padding-top": "0px !important",
      "padding-bottom": "0px !important"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("The next level of dog boarding")]), _vm._v(" "), (_vm.switchAccountComp) ? _c('h3', {
    staticClass: " alert alert-info"
  }, [_vm._v("Please login again to complete switching your account")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.notification) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible"
  }, [_vm._m(1), _vm._v(" "), _c('strong'), _vm._v(_vm._s(_vm.notification) + "\r\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "well",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "inner-addon right-addon"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), (_vm.credentials.username) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has('email')),
      expression: "!errors.has('email')"
    }],
    staticClass: "fa fa-paw text-success "
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.credentials.username),
      expression: "credentials.username",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'has-error': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.validateBeforeSubmit()
      },
      "change": function($event) {
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help-inline text-danger h5"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "inner-addon right-addon"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), (_vm.credentials.password) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has('password')),
      expression: "!errors.has('password')"
    }],
    staticClass: "fa fa-paw text-success "
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'has-error': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password",
      "data-vv-delay": "1500"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.validateBeforeSubmit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger h5"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block btn-title",
    attrs: {
      "disabled": _vm.filledRequired == false
    },
    on: {
      "click": function($event) {
        _vm.validateBeforeSubmit()
      }
    }
  }, [_vm._v("Login")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled",
    staticStyle: {
      "line-height": "2"
    }
  }, [_c('li', [_c('a', {
    staticClass: "btn btn-lg btn-title btn-block btn-social btn-facebook",
    staticStyle: {
      "background-color": "#4267b2",
      "color": "#fff",
      "margin": "20px auto 0px auto"
    }
  }, [_c('span', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" "), _c('fb-signin-button', {
    staticClass: "text-center",
    attrs: {
      "params": _vm.fbSignInParams
    },
    on: {
      "success": _vm.onSignInSuccess,
      "error": _vm.onSignInError
    }
  }, [_vm._v("\r\n                              Continue with Facebook Account\r\n                            ")])], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block btn-title",
    on: {
      "click": function($event) {
        _vm.goSignup()
      }
    }
  }, [_vm._v("Register with your Email")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "14px"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.forgotPassword()
      }
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }), _vm._v(" "), _vm._m(2)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small",
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("By registering you agree to our "), _c('a', {
    attrs: {
      "href": "/terms-and-conditions"
    }
  }, [_vm._v("terms and conditions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d15e9156!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/Login.vue
// module id = 659
// module chunks = 2